// import { vRequest } from "@/utils/vRequest";
import { request } from "@/utils/request";



// 获取任务列表接口
export const GetTaskList = (data: any) => {
  return request.post<any>("/ext/request", {
    ...data,
    tasktype: "transfer",
    service: "App.Sip_Yccall.TaskList",
    token: localStorage.getItem("token") || "",
    url: localStorage.getItem("call_node") || "",
  });
};


// 查看通话详情
export const GetCallDetail = (data: any) => {
  return request.post<any>("/ext/request", {
    ...data,
    service: "App.Sip_Yccall.TaskInfo",
    token: localStorage.getItem("token") || "",
    url: localStorage.getItem("call_node") || "",
  });
};
// 查看通话详情
export const EditCallDetail = (data: any) => {
  return request.post<any>("/ext/request", {
    ...data,
    service: "App.Sip_Customer.editTaskDetail",
    token: localStorage.getItem("token") || "",
    url: localStorage.getItem("call_node") || "",
  });
};

// 呼叫
export const HandleUp = (data: any) => {
  return request.post<any>("/ext/request", {
    ...data,
    service: "App.Sip_Call.MakeCall",
    token: localStorage.getItem("token") || "",
    url: localStorage.getItem("call_node") || "",
  });
};

// 挂断
export const CloseCall = (data: any) => {
  return request.post<any>("/ext/request", {
    ...data,
    service: "App.Sip_Call.HangupCall",
    token: localStorage.getItem("token") || "",
    url: localStorage.getItem("call_node") || "",
  });
};

// 创建任务
export const AddTask = (data: any) => {
  return request.post<any>("/ext/request", {
    ...data,
    assigntype: 1,
    taskscale: "1:1",
    disnumber: "",
    service: "App.Sip_Yccall.TaskCreat",
    token: localStorage.getItem("token") || "",
    url: localStorage.getItem("call_node") || "",
  });
};

// 开启任务
export const StartTask = (data: any) => {
  return request.post<any>("/ext/request", {
    ...data,
    taskstatus: 1,
    service: "App.Sip_Yccall.TaskSet",
    token: localStorage.getItem("token") || "",
    url: localStorage.getItem("call_node") || "",
  });
};

// 获取分机状态
export const GetStatus = (data: any) => {
  return request.post<any>("/ext/request", {
    ...data,
    service: "App.Sip_Status.GetSipRegisterStatus",
    token: localStorage.getItem("token") || "",
    url: localStorage.getItem("call_node") || "",
  });
};


// 编辑状态
export const EditTaskStatus = (taskId:string,status:number) => {
  return request.post<any>("/ext/request", {
    taskid:taskId,
    taskstatus:status,
    service: "App.Sip_Yccall.TaskSet",
    token: localStorage.getItem("token") || "",
    url: localStorage.getItem("call_node") || "",
  });
};




// 获取分机对应的组列表
export const GetGroup = (data: any) => {
  return request.post<any>("/ext/request", {
    ...data,
    service: "App.Sip_Extgroup.getAllExtGroup",
    token: localStorage.getItem("token") || "",
    url: localStorage.getItem("call_node") || "",
  });
};

export const GetCallList = (data: any) => {
  return request.post<any>("/ext/callList", {
    ...data,
    token: localStorage.getItem("token") || "",
  });
};

// 添加备注
export function AddRemark(data: any) {
  return request.post<any>("/ext/addRemark", {
    ...data,
    token: localStorage.getItem("token") || "",
  });

}

export function CreateTask(data: any) {
  return request.post<any>("/ext/request", {
    ...data,
    service: "App.Sip_Yccall.TaskCreat",
    token: localStorage.getItem("token") || "",
    url: localStorage.getItem("call_node") || "",
  });

}
// 添加备注
export function AppendPhone(data: any) {
  return request.post<any>("/ext/request", {
    ...data,
    service: "App.Sip_Yccall.TaskAdd",
    token: localStorage.getItem("token") || "",
    url: localStorage.getItem("call_node") || "",
  });

}

// 添加备注
export function RemovePhone(data: any) {
  return request.post<any>("/ext/request", {
    ...data,
    service: "App.Sip_Yccall.taskDelPhone",
    token: localStorage.getItem("token") || "",
    url: localStorage.getItem("call_node") || "",
  });

}

// 获取通话列表接口
export const getAgentCallLog = (data: any) => {
  return request.post<any>("ext/callRecord", {
    ...data,
    syncflag: 3,
    direction: 3,
    callmethod: 3,
    service: "App.Sip_Cdr.GetBill",
    token: localStorage.getItem("token") || "",
    url: localStorage.getItem("call_node") || "",
  });
};

// 文件上传（带参数）
export const UploadFile = (data: any) => {
  // 如果data包含文件，需要特殊处理
  if (data.file) {
    const formData = new FormData();
    // 修改字段名为后端期望的 'phone_file'
    formData.append('phone_file', data.file);

    // 添加其他参数
    Object.keys(data).forEach(key => {
      if (key !== 'file') {
        formData.append(key, data[key]);
      }
    });

    // 添加token和其他必要参数
    formData.append('token', localStorage.getItem("token") || "");
    formData.append('extnumber', data.extnumber);

    return request.post<any>("/ext/add", formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
};

